import { formatPrice } from "@/common/utils/intl.utils";

/**
 * Format an amount on a product card, a list place: a whole amount reads
 * `€ 450`, without the Dutch `,-` (price display policy, WHO-5995). The search
 * API already resolves every price it returns (`originalPrice`, `buyNowPrice`,
 * `discountPercentage`, `bidFrom`) and sends card prices whole, so the client
 * formats and never recomputes or rounds.
 *
 * `currency` and `locale` are free-form strings from the API and the router;
 * `formatPrice` types them as unions — cast the options bag at this one boundary.
 */
export const formatAmount = (
  amount: number | null | undefined,
  currency: string,
  locale?: string
): string | null => {
  if (amount == null) {
    return null;
  }

  const options = { currency, locale, place: "list" } as Parameters<
    typeof formatPrice
  >[1];
  return formatPrice(amount, options);
};
